import { createReducer, on } from '@ngrx/store';
import { 
    fetchSingleRecordSuccess,
    resetState,
    updateRecordSuccess
} from './penalty-fee.action';
import { PenaltyFee } from './penalty-fee.model';

export interface PenaltyFeeRecordsState {
    listData: PenaltyFee[];
    singleData: PenaltyFee;
    loading: boolean;
    error: any;
    total: number;
}

export const initialState: PenaltyFeeRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0
};


export const PenaltyFeeRecordReducer = createReducer(

    initialState,
    
    // FETCH RECORDS
    on(fetchSingleRecordSuccess, (state, { listData }) => {
        return { ...state, listData, loading: false, error: null };
    }),

    // RECORD UPDATE AND FETCH BACK
    on(updateRecordSuccess, (state, { singleData }) => {
        return { ...state, singleData, loading: false, error: null };
    }),

    //RESET STATE
    on(resetState, () => initialState)  // Reset action handler
    
);